<template>
  <div class="flex flex-col gap-10 relative">
    <!-- Favorites Section -->
    <ContentRow
      v-if="favoriteMods.length > 0"
      :mods="favoriteMods"
      :title="$t('play.play_now.your_favorites')"
      icon="heart"
      iconColor="#C44CB6"
      @selectMod="selectMod"
      :selectedMod="selectedMod"
      :showCategory="true"
      :modCategories="modCategories"
      :limitMods="false"
    />

    <!-- Empty state when no favorites and data is loaded -->
    <div v-else-if="isDataLoaded" class="flex flex-col items-center justify-center py-16 text-center">
      <img
        src="../../assets/icons/heart.svg"
        class="h-12 w-12 opacity-40 mb-4"
        :alt="$t('play.play_now.heart_icon_alt')"
      />
      <h3 class="text-lg font-medium text-text-secondary mb-2">{{ $t('play.play_now.favorites_empty_title') }}</h3>
      <p class="text-text-secondary max-w-md">
        {{ $t('play.play_now.favorites_empty_body') }}
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useAuth } from '@websanova/vue-auth/src/v3.js';
import ContentRow from './ContentRow.vue';
import { favoriteModIds } from '../../utils/user_preferences.js';

const store = useStore();

// Get current user for access level check
const auth = useAuth();
const currentUser = ref(auth.user());

const props = defineProps({
  selectedMod: {
    type: Object,
    required: true,
  },
  modCategories: {
    type: Array,
    required: false,
    default: () => [],
  },
  isDataLoaded: {
    type: Boolean,
    required: false,
    default: true,
  },
});

const emit = defineEmits(['selectMod']);

function selectMod(mod) {
  emit('selectMod', mod);
}

const mods = computed(() => store.state.modInfo?.mods?.filter((mod) => mod.playable && mod.cs2) || []);

const favoriteMods = computed(() => mods.value?.filter((mod) => {
  if (!favoriteModIds.value.includes(mod.id)) return false;

  if (mod.name.toLowerCase() === 'scrim' && (!currentUser.value || currentUser.value.access_level <= 1)) {
    return false;
  }

  return true;
}) || []);

// Function to get the auto-selection mod based on priority
function getAutoSelectionMod() {
  // Return first favorite mod if available
  if (favoriteMods.value.length > 0) {
    return favoriteMods.value[0];
  }

  return null;
}

defineExpose({
  getAutoSelectionMod,
});
</script>
